import requests from "../util";
const { request, requestXlsxFileDownload } = requests;

const createNewBatch = (payload) => {
  return request({
    url: "/api/v1/batch",
    method: "post",
    body: payload,
  });
};
const fetchAllBatches = (pageNum, pageSize) => {
  let params = { pageNum, pageSize };
  return request({
    url: "/api/v1/batch/listBatchesWithDetail",
    method: "get",
    params: params,
  });
};

const addNewMarketplaceForUser = (payload) => {
  return request({
    url: "/api/v1/marketplace/addNewMarketplaceForUser",
    method: "post",
    body: payload,
  });
};

const listAddOnServices = (pageNum, pageSize) => {
  const params = {
    pageNum,
    pageSize,
  };

  return request({
    url: "/api/v1/service/listAddOnServices",
    method: "get",
    params,
  });
};

const getPresignedUrlForGuidelineReferenceFileUpload = async ({
  filename,
  mimeType,
}) => {
  const params = {
    filename,
    mimeType,
  };
  return request({
    url: "/api/v1/guideline/getPresignedUrlForGuidelineReferenceFileUpload",
    method: "get",
    params,
  });
};
const getPresignedUrlForAddOns = async ({ filename, mimeType }) => {
  const params = {
    filename,
    mimeType,
  };
  return request({
    url: "/api/v1/draftSku/getPresignedUrlForAddOns",
    method: "get",
    params,
  });
};
const attachMarketPlaces = (payload) => {
  return request({
    url: "/api/v1/batch/attachMarketplaces",
    method: "patch",
    body: payload,
  });
};
const getPresignedUrlBulkUpload = async (payload) => {
  return request({
    url: "/api/v1/uploadedFile/presignedUrlBulk",
    method: "post",
    body: payload,
  });
};

const createFiles = async (payload) => {
  return request({
    url: "/api/v1/uploadedFile/createFiles",
    method: "post",
    body: payload,
  });
};
const addActionToAddOnInDraftSku = async (payload) => {
  return request({
    url: "api/v1/draftSku/addActionToAddOnInDraftSku",
    method: "patch",
    body: payload,
  });
};
const getBatchSkuList = (batchId) => {
  return request({
    url: `/api/v1/batch/getBatchDetailsWithSkus/${batchId}`,
    method: "get",
  });
};
const deleteFolder = (payload) => {
  return request({
    url: "/api/v1/uploadedFile/deleteUploadFolder",
    method: "delete",
    body: payload,
  });
};

const attachAddOnServices = (payload) => {
  return request({
    url: `/api/v1/batch/attachAddOnServices`,
    method: "patch",
    body: payload,
  });
};
const getBatchSummary = (batch) => {
  return request({
    url: `/api/v1/batch/summary`,
    method: "get",
    params: { batch },
  });
};

const completeOrderCreation = (batchId, payload) => {
  return request({
    url: `/api/v1/batch/completeOrderCreation/${batchId}`,
    method: "patch",
    body: payload,
  });
};

const removeAddOnServiceFromAnSku = (payload) => {
  return request({
    url: `api/v1/draftSku/removeAddOnServiceFromAnSku`,
    method: "patch",
    body: payload,
  });
};
const deleteDraftSkuForUser = (payload) => {
  return request({
    url: `api/v1/draftSku/deleteDraftSkuForUser`,
    method: "patch",
    body: payload,
  });
};
const getListAddOns = (draftSkuId) => {
  if (!draftSkuId) {
    return null;
  }
  return request({
    url: `/api/v1/draftSku/listAddOns`,
    method: "get",
    params: {
      draftSkuId,
    },
  });
};

const upsertAddOnServiceToSku = (payload) => {
  return request({
    url: `/api/v1/draftSku/upsertAddOnServiceToSku`,
    method: "patch",
    body: payload,
  });
};

const getPresignedUrlForCSV = async ({ batchId, filename, mimeType }) => {
  const params = {
    batchId,
    filename,
    mimeType,
  };
  return request({
    url: "/api/v1/batch/getPresignedUrlForCSV",
    method: "get",
    params,
  });
};
const getPresignedUrlForRichTextEditor = async ({
  batchId,
  filename,
  mimeType,
}) => {
  const params = {
    batchId,
    filename,
    mimeType,
  };
  return request({
    url: "/api/v1/batch/getPresignedUrlForAssetUploadForRichText",
    method: "get",
    params,
  });
};

const getCsvData = async (batchId) => {
  const params = {
    batch: batchId,
  };
  return request({
    url: "/api/v1/batch/csv",
    method: "get",
    params,
  });
};
const attachCsvToBatch = async (payload) => {
  return request({
    url: "/api/v1/batch/attachCsvToBatch",
    method: "post",
    body: payload,
  });
};
const updateBillingInformation = (payload) => {
  return request({
    url: "/api/v1/organization/billing",
    method: "patch",
    body: payload,
  });
};
const getBillingInformation = async () => {
  return request({
    url: "/api/v1/organization/billing",
    method: "get",
  });
};
const getBatchOverview = async () => {
  return request({
    url: "/api/v1/batch/getBatchOverview",
    method: "get",
  });
};
const initiateCheckoutForBatch = async (payload) => {
  return request({
    url: "/api/v1/batch/initiateCheckoutForBatch",
    method: "post",
    body: payload,
  });
};
const batchQuoteInfo = async (batchId) => {
  let params = { batch: batchId };
  return request({
    url: "/api/v1/batch/quoteInfo",
    method: "get",
    params,
  });
};
const getPaymentInfo = async (id) => {
  return request({
    url: `/api/v1/batch/checkout/info/${id}`,
    method: "get",
  });
};

const getBatchCSV = async (id) => {
  return await requestXlsxFileDownload({
    url: `/api/v1/batch/csv?batch=${id}`,
    method: "get",
  });
};
const orderBatchesApi = {
  createNewBatch,
  fetchAllBatches,
  addNewMarketplaceForUser,
  listAddOnServices,
  getPresignedUrlForGuidelineReferenceFileUpload,
  attachMarketPlaces,
  getPresignedUrlBulkUpload,
  createFiles,
  getBatchSkuList,
  deleteFolder,
  attachAddOnServices,
  getBatchSummary,
  getPresignedUrlForAddOns,
  addActionToAddOnInDraftSku,
  completeOrderCreation,
  removeAddOnServiceFromAnSku,
  getListAddOns,
  getPresignedUrlForCSV,
  upsertAddOnServiceToSku,
  attachCsvToBatch,
  getCsvData,
  deleteDraftSkuForUser,
  updateBillingInformation,
  getBillingInformation,
  initiateCheckoutForBatch,
  batchQuoteInfo,
  getPaymentInfo,
  getPresignedUrlForRichTextEditor,
  getBatchOverview,
  getBatchCSV,
};

export default orderBatchesApi;
